import e from "react";
import { BackIcon as l } from "../../components/BackIcon.js";
import t from "./titlePage.module.scss.js";
function i({
  title: a
}) {
  return /* @__PURE__ */ e.createElement("div", { className: t.titlePage }, /* @__PURE__ */ e.createElement(l, null), /* @__PURE__ */ e.createElement("div", { className: t.titlePage__text }, a));
}
export {
  i as TitlePage
};
//# sourceMappingURL=TitlePage.js.map
